// Surface card + section header. Ported from botriq-admin-fe's Robot Portal UI kit.
import { forwardRef } from "react";
import PropTypes from "prop-types";
import { Icon } from "./Icon";

export const Card = forwardRef(({ children, style, ...rest }, ref) => (
  <div
    ref={ref}
    style={{
      background: "var(--bq-surface)",
      border: "1px solid var(--bq-border)",
      borderRadius: 12,
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
));

Card.displayName = "Card";
Card.propTypes = { children: PropTypes.node, style: PropTypes.object };

const SECTION_ICON_TONES = {
  accent: ["var(--bq-accentSoft)", "var(--bq-accent)"],
  success: ["var(--bq-successSoft)", "var(--bq-success)"],
  warning: ["var(--bq-warningSoft)", "var(--bq-warning)"],
  danger: ["var(--bq-dangerSoft)", "var(--bq-danger)"],
};

export const SectionHead = ({ title, sub, right, icon, iconTone = "accent" }) => {
  const [bg, fg] = SECTION_ICON_TONES[iconTone] || SECTION_ICON_TONES.accent;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 14px",
        borderBottom: "1px solid var(--bq-border)",
      }}
    >
      {icon && (
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: 8,
            flex: "none",
            display: "grid",
            placeItems: "center",
            background: bg,
            color: fg,
          }}
        >
          <Icon name={icon} size={15} />
        </div>
      )}
      <div style={{ minWidth: 0 }}>
        <div
          style={{ fontSize: 13, fontWeight: 600, color: "var(--bq-text)", whiteSpace: "nowrap" }}
        >
          {title}
        </div>
        {sub && (
          <div
            style={{
              fontSize: 11.5,
              color: "var(--bq-text3)",
              marginTop: 2,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {sub}
          </div>
        )}
      </div>
      {right && (
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
          {right}
        </div>
      )}
    </div>
  );
};

SectionHead.propTypes = {
  title: PropTypes.node,
  sub: PropTypes.node,
  right: PropTypes.node,
  icon: PropTypes.string,
  iconTone: PropTypes.oneOf(["accent", "success", "warning", "danger"]),
};

export default Card;
